import { LitElement, html, css, PropertyValues, nothing } from 'lit';
import {property, customElement} from 'lit/decorators.js';
import { SvgIcons } from '../../voyage-svg-icons/src/voyage-svg-icons';

@customElement('voy-panel')
export class VoyPanel extends LitElement {

    @property({ type: String }) panelTitle: string = "";
    @property({ type: Boolean, reflect: true }) shown: boolean = false;
    @property({ type: Boolean, reflect: true }) transparent: boolean = false;
    @property({ type: Boolean, reflect: true }) showCloseBtn: boolean = false;
    @property({ type: Boolean, reflect: true }) showOnTop: boolean = false;
    
    constructor() {
        super();

        this._close = this._close.bind(this)
    }
    static get styles() {
        return [
            css`
                :host {
                    display: flex;
                    flex-direction: column;
                    box-sizing: border-box;
                    background: white;
                    transition: transform 150ms ease-out;
                    border: 1px solid var(--functional-grey-400, grey);
                    box-shadow: 2px 2px 8px var(--secondary-voyage-box-shadow);
                    border-radius: 4px 4px 4px 4px;
                }

                :host([showOnTop]) {
                    z-index: 50;
                }

                :host([transparent]) {
                    opacity: 0.5;
                }

                :host(:hover) {
                    opacity: 1;
                }

                #topbar {
                    width: 100%;
                    padding: 16px;
                    touch-action: none;
                    display: grid;
                    grid-template-columns: 1fr auto;
                    align-items: center;
                    border-bottom: 1px solid var(--functional-grey-600, grey);
                    box-sizing: border-box;
                    user-select: none;
                }

                .panelTitle {
                    grid-column: 1;
                    font-family: var(--component-paragraph-ff, 'serif');
                    font-size: 20px;
                }

                .close {
                    grid-column: 2;
                    background: none;
                    border: none;
                    outline: none;
                    cursor: pointer;
                    padding: 12px 10px 10px;
                    fill: var(--neutrals-grey-02, black);
                }

                .close > svg {
                    display: block;
                    width: 13px;
                }

                .container {
                    padding: 16px;
                    overflow-y: scroll;
                    height: 100%;
                }
            `
        ]   
    };

    render() {
        return html`
        <div id="topbar">
            <div class="panelTitle">${this.panelTitle}</div>
            ${this.showCloseBtn
                ? html`<button class="close" @click=${this._close}>${SvgIcons.lightTimes}</button>`
                : nothing}
        </div>
        <div class="container"><slot></slot></div>
        `;
    }

    private _close(evt:Event) {
        this.dispatchEvent(new Event('close'));
        evt.stopPropagation();
        return false;
    }
}
